import { HStack } from "@chakra-ui/react";
import * as React from "react";
import { LuArrowDown, LuArrowUp } from "react-icons/lu";

export type BadgeTone = "good" | "bad" | "warn" | "flat";

const TONE_STYLES: Record<BadgeTone, { background: string; color: string }> = {
  good: { background: "pill.green.bg", color: "pill.green.text" },
  bad: { background: "pill.red.bg", color: "pill.red.text" },
  warn: { background: "warn.bg", color: "warn.text" },
  flat: { background: "bg.hover", color: "fg.muted" },
};

export function ToneBadge({
  tone,
  children,
}: {
  tone: BadgeTone;
  children: React.ReactNode;
}) {
  const styles = TONE_STYLES[tone];
  return (
    <HStack
      background={styles.background as any}
      borderRadius="l1"
      color={styles.color as any}
      display="inline-flex"
      flexShrink="0"
      fontSize="xs"
      fontWeight="medium"
      gap={"3px" as any}
      height="5"
      lineHeight={"12px" as any}
      paddingX="1"
      whiteSpace="nowrap"
    >
      {children}
    </HStack>
  );
}

export const DELTA_BADGE_THRESHOLD = 4;

interface DeltaBadgeProps {
  now: number;
  before: number;
  lowerIsBetter?: boolean;
}

export function DeltaBadge({
  now,
  before,
  lowerIsBetter = true,
}: DeltaBadgeProps) {
  if (before === 0) return null;
  const pct = Math.round(((now - before) / before) * 100);
  const abs = Math.abs(pct);
  if (abs < DELTA_BADGE_THRESHOLD) return null;
  const isGood = lowerIsBetter ? pct < 0 : pct > 0;
  return (
    <ToneBadge tone={isGood ? "good" : "bad"}>
      {pct < 0 ? <LuArrowDown size="12" /> : <LuArrowUp size="12" />}
      {abs}%
    </ToneBadge>
  );
}
